import { SidebarMenuButton, SidebarMenuItem } from '@osteopro/ui';
import { Percent } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useEntitlements } from '../../hooks/api/use-plans.js';
import { useOrganization } from '../../lib/auth-provider.js';
import { showsRetrocessionNav } from '../../lib/retrocession-access.js';

/**
 * Entrée « Rétrocessions » de l'espace de travail, après Facturation.
 * Absente tant que l'offre ou le rôle ne l'ouvrent pas : cacher le lien n'est pas le droit,
 * l'adresse reste servie et l'écran dit pourquoi.
 */
export function RetrocessionNavItem({
  location,
  onNavigate,
}: {
  location: string;
  onNavigate: (url: string) => void;
}) {
  const { t } = useTranslation();
  const { organization } = useOrganization();
  const entitlements = useEntitlements();
  if (!showsRetrocessionNav(entitlements.data?.plan, organization?.role)) return null;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        isActive={location.startsWith('/retrocessions')}
        onClick={() => {
          onNavigate('/retrocessions');
        }}
        tooltip={t('settings:retrocession.screen_title')}
        data-testid="nav-retrocessions"
      >
        <Percent className="h-5 w-5" />
        <span className="font-medium">{t('settings:retrocession.screen_title')}</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
